export default __webpack_public_path__ + "829bfb2d2aab9992b7b655703e5819a8.jpg";